import { TicketDetail } from "./order";
export enum NextActionTransaction {
	close = "close",
	print = "print"
}

export class TransactionAction {
	nextAction: NextActionTransaction;
	ticketDetail: TicketDetail = new TicketDetail();
}
